var _circle, _path, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlertCloud48Px = function SvgAlertCloud48Px(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1865,
    cy: 32.75,
    r: 9.37037,
    stroke: "#606163",
    strokeWidth: 1.25926
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6855 34L10.1855 34C6.73376 34 3.93554 31.2018 3.93554 27.75C3.93554 24.2982 6.73376 21.5 10.1855 21.5C10.1855 18.0482 12.9838 15.25 16.4355 15.25C16.7447 15.25 17.0486 15.2725 17.3457 15.3158C18.9987 11.5949 22.7266 9 27.0606 9.00001C31.9343 9.00001 36.0416 12.2815 37.2936 16.7556C41.1078 17.699 43.9355 21.1443 43.9355 25.25C43.9355 29.2138 41.2999 32.562 37.6856 33.6377",
    stroke: "#606163",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1855 27.75L25.1855 34",
    stroke: "#606163",
    strokeWidth: 1.88889,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1855,
    cy: 37.7501,
    r: 1.25,
    fill: "#606163"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlertCloud48Px);
export default ForwardRef;